import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/provideUsFeedback";
import { fetchConfig } from "../../../common/util/config";
import "./ProvideUsFeedback.scss";
import useWindowSize from "../../../common/hooks/useWindowSize";
import { createPortal } from "react-dom";

export default function ProvideUsFeedback() {
  const { t } = useTranslation(["provideUsFeedback"]);
  useEffect(() => {
    const iFrame = createIframe();
    fetchConfig().then((config) => {
      iFrame.setAttribute("src", config.corePlusSurvey);
      iFrame.setAttribute("title", t("pageTitle", defaultContent["pageTitle"]).toString());
    });
  }, [t]);
  const feedbackHeader = (
    <div className="feedback__header">
      <h2 className="feedback__header__title">{t("pageTitle", defaultContent["pageTitle"])}</h2>
    </div>
  );

  const { width } = useWindowSize();
  const [portalTarget, setPortalTarget] = useState<Element | null>(null);

  useEffect(() => {
    setPortalTarget(document.querySelector("#title-portal"));
  }, [width]);
  const portalFlag = portalTarget !== null;
  return (
    <div className="feedback">
      {portalFlag && portalTarget ? (
        createPortal(feedbackHeader, portalTarget)
      ) : (
        <div className="feedback__header">
          <h2 className="feedback__header__title">{t("pageTitle", defaultContent["pageTitle"])}</h2>
        </div>
      )}
      <div id="iframeWrapper"></div>
    </div>
  );
}
export function createIframe() {
  const cpSurvey = document.createElement("iframe");
  cpSurvey.setAttribute("scrolling", "no");
  cpSurvey.setAttribute("className", "survey");
  cpSurvey.setAttribute("id", "frame");
  document.body.appendChild(cpSurvey);
  document.getElementById("iframeWrapper")?.appendChild(cpSurvey);
  return cpSurvey;
}
